<div class="tw-flex tw-items-center tw-my-2">
  <div class="tw-flex tw-w-full tw-items-center tw-space-x-1">
    <mat-form-field appearance="outline" class="type-select">
      <mat-select
        [formControl]="typeControl"
        (selectionChange)="onTypeChange()"
      >
        <mat-select-trigger>
          <div class="trigger-content">
            <span>{{ typeControl.value || "Todos" }}</span>
          </div>
        </mat-select-trigger>

        <mat-option value="">Todos</mat-option>
        <mat-option value="Work Orders">Work Orders</mat-option>
        <mat-option value="Assembly Items">Assembly Items</mat-option>
        <mat-option value="Serialized Part">Pieza serializada</mat-option>
        <mat-option value="Transactions">Transactions</mat-option>
        <mat-option value="Users">Users</mat-option>
        <mat-option value="Rutas">Rutas</mat-option>
        <mat-option value="Packing Box">Packing Box</mat-option>
        <mat-option value="Pallet">Pallet</mat-option>
        <mat-option value="Camiones">Camiones</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      class="search-field tw-flex tw-flex-grow tw-w-full"
    >
      <mat-icon matPrefix>search</mat-icon>

      <input
        [formControl]="formControl"
        matInput
        placeholder="Buscar..."
        #inputRef
        (focus)="openAutocomplete()"
      />

      <button
        mat-icon-button
        *ngIf="formControl.value"
        matSuffix
        (click)="clearSearch()"
        aria-label="Borrar búsqueda"
      >
        <mat-icon>close</mat-icon>
      </button>

      <div class="autocomplete-list" *ngIf="showOptions$ | async">
        <div class="skeleton-container" *ngIf="isLoading">
          <div class="skeleton-item" *ngFor="let _ of skeletonArray"></div>
        </div>

        <mat-list *ngIf="!isLoading">
          <ng-container *ngFor="let option of searchOptions$ | async">
            <mat-divider></mat-divider>
            <h4>{{ option.type }}</h4>
            <ng-container
              *ngFor="let op of option.data"
              [ngTemplateOutlet]="templateOption"
              [ngTemplateOutletContext]="{ option: op }"
            >
            </ng-container>
          </ng-container>

          <ng-container *ngIf="!(searchOptions$ | async)?.length">
            <mat-divider></mat-divider>
            <mat-list-item disabled>No hay resultados</mat-list-item>
          </ng-container>
        </mat-list>
      </div>
    </mat-form-field>
  </div>

  <ng-template #templateOption let-op="option">
    <a [routerLink]="[op.url]">
      <div class="option-item" (click)="closeAutocomplete()">
        <div class="option-content tw-flex tw-flex-col tw-flex-wrap">
          <span class="tw-flex tw-flex-row tw-items-center tw-justify-center">
            <mat-icon [ngClass]="op.color | toIconColor">
              {{ op.icon }}
            </mat-icon>
            <div class="status-indicator" [ngClass]="op.color"></div>
          </span>
          <h3
            class="
              tw-flex tw-flex-row tw-flex-wrap tw-items-center tw-justify-center
            "
          >
            {{ op.title }}
          </h3>

          <mat-chip-listbox class="chip-list">
            <mat-chip-row
              *ngFor="let chip of op.chips"
              [class]="chip.toLowerCase()"
            >
              {{ chip }}
            </mat-chip-row>
          </mat-chip-listbox>
        </div>
      </div>
    </a>
  </ng-template>
</div>
